import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  TimePicker as Mui4TimePicker,
  TimePickerProps as Mui4TimePickerPropsType,
} from '@material-ui/pickers'
import { TimePicker as MuiX7TimePicker, TimePickerProps as MuiX7TimePickerPropsType } from '@mui/x-date-pickers'
import { forwardRef, useState } from 'react'
import { useComponentVersion } from '../hooks'
import { CustomActionBar } from '../other/timePicker/TimePickerActionBar'
import { TIME_PICKER_PROPS, withPickerDayjs } from '../utils/pickerDateValues'
import { OsDatePickerVersion } from './DatePicker'
import { Icon } from './Icon'
import { IconButton } from './IconButton'

export type TimePickerProps = Mui4TimePickerPropsType & {
  slotProps?: MuiX7TimePickerPropsType<any, boolean>['slotProps']
}

// * MUI DateTimePicker API Spec  https://mui.com/x/react-date-pickers/time-picker/
export const TimePicker = forwardRef<HTMLDivElement, TimePickerProps>((props, ref) => {
  const version = useComponentVersion('date_picker')
  const [open, setOpen] = useState(false)

  const { slotProps, ...rest } = props

  switch (version) {
    case OsDatePickerVersion.V2: {
      return (
        <MuiX7TimePicker
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          slots={{
            actionBar: CustomActionBar,
          }}
          ref={ref}
          slotProps={{
            dialog: {
              sx: {
                zIndex: 2000,
              },
            },
            popper: {
              sx: {
                zIndex: 2000,
              },
            },
            textField: (ownerState) => ({
              ...ownerState,
              ...slotProps?.textField,
              InputProps: {
                ...ownerState.InputProps,
                // @ts-ignore
                ...slotProps?.textField?.InputProps,
                endAdornment: (
                  <IconButton
                    sx={{ width: 20, height: 20, '&:hover': { backgroundColor: 'transparent' } }} // Adding custom styles to the IconButton to match the design
                    onClick={() => setOpen(true)}
                  >
                    <Icon icon="schedule" size={'small'} />
                  </IconButton>
                ),
              },
              helperText: props.helperText,
            }),
          }}
          {...withPickerDayjs(rest as MuiX7TimePickerPropsType<any, boolean>, ...TIME_PICKER_PROPS)}
        />
      )
    }

    default:
      return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Mui4TimePicker ref={ref} {...props} />
        </MuiPickersUtilsProvider>
      )
  }
})
